import ClearanceCertificateObligationSummary from './ClearanceCertificateObligationSummary'

export default ClearanceCertificateObligationSummary
